<script setup lang="ts">
import { ToastTitle, type ToastTitleProps } from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'

const props = defineProps<ToastTitleProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props

	return delegated
})
</script>

<template>
	<toast-title v-bind="delegatedProps" :class="cn('text-sm font-semibold [&+div]:text-xs', props.class)">
		<slot />
	</toast-title>
</template>
